import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ApplicationEventService } from '~shared/modules/application-event/services/application-event.service';
import { Router } from '@angular/router';
import { Category } from '~app/modules/generic/models';
import { NavigationApplicationEvent } from '~shared/modules/application-event/models';
import { ApplicationNavigationEventType } from '~shared/modules/application-event/constants';
import { CategoryImagesUtil } from '~app/modules/catalog/utils/category-images.util';
import { environment } from '~env/environment';
import { ZRPCategoryClickedApplicationEvent } from '~shared/modules/application-event/models/zrp-category-clicked-application-event.model';
import { getCountryDomainCode } from '~server/utils/country-detection.util';

enum CategoryImageSizes {
  mobile = 48,
  desktop = 88,
}

const CATEGORY_PLACEHOLDER_IMG = 'images/product-catalog-placeholder.png';

@Component({
  selector: 'app-category-bubble',
  templateUrl: './category-bubble.component.html',
  styleUrls: ['./category-bubble.component.scss'],
})
export class CategoryBubbleComponent {
  @Input() category: Category;
  @Input() title: string;
  @Input() isMobile?: boolean = true;
  @Input() promotion?: boolean;
  @Input() isZeroResultsPage?: boolean;
  @Input() searchTerm?: string;
  @Input() isInNavigationMenu?: boolean = false;
  @Output() closeNestedCategoriesPopover = new EventEmitter();
  @Output() categoryClick: EventEmitter<Category> = new EventEmitter();

  get categoryName(): string {
    const limitReference = this.isMobile ? this.MAX_DISPLAYED_CHARS_MOBILE : this.MAX_DISPLAYED_CHARS_DESKTOP;
    const slicedName = this.category.name.slice(0, limitReference);
    if (this.category.name.indexOf(' ') < 0 && !this.isInNavigationMenu) {
      return this.category.name.length > limitReference ? slicedName + '...' : this.category.name;
    }

    return this.category.name;
  }

  readonly MAX_DISPLAYED_CHARS_DESKTOP = 16;
  readonly MAX_DISPLAYED_CHARS_MOBILE = 10;
  defaultCategoryImage = `${environment.cdnBaseUrl()}/${CATEGORY_PLACEHOLDER_IMG}`;
  market: string;

  constructor(private applicationEventService: ApplicationEventService, private router: Router) {
    this.market = getCountryDomainCode();
  }

  onCategoryClick(category: Category): void {
    if (this.isZeroResultsPage) {
      this.applicationEventService.publish(
        new ZRPCategoryClickedApplicationEvent(category.name, `${this.searchTerm} online kaufen | suchergebnisse`)
      );

      return;
    }

    this.applicationEventService.publish(
      new NavigationApplicationEvent(
        ApplicationNavigationEventType.PLPCategoryNavigation,
        `Category carousel component = ${this.title}`,
        this.router.url,
        { categoryName: category.name }
      )
    );
    this.closeNestedCategoriesPopover.emit();
  }

  getSource(srcGet: string, categoryId: string): string {
    const imageSize = this.isMobile ? CategoryImageSizes.mobile : CategoryImageSizes.desktop;
    return CategoryImagesUtil[srcGet](categoryId, imageSize, imageSize);
  }

  navigateTo(category: Category): void {
    this.categoryClick.emit(category);
  }
}
